// Determine the API URL based on environment
// In production, the frontend is served by the backend, so we use relative URLs (empty string)
// In development, we use localhost
const getApiUrl = () => {
  // If explicitly set, use that
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // In local environment, use localhost
  if (process.env.REACT_APP_IS_LOCAL === 'true') {
    return "http://localhost:8080";
  }
  
  // In production, use same origin (empty string makes requests relative to current host)
  return "";
};

const config = {
  apiUrl: getApiUrl(),
  environment: process.env.NODE_ENV,
  useMockData: process.env.REACT_APP_USE_MOCK_DATA === 'true',
  isOfflineMode: process.env.REACT_APP_OFFLINE_MODE === 'true',
  isLocal: process.env.REACT_APP_IS_LOCAL === 'true',
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || '',
    audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  },
};

export default config;